import {Box} from 'components/Grid';
import {Typography} from 'components/Typography';
import {EventsList} from 'modules/events/components/EventsList';
import {getEventDate, getEventDayOfWeek} from 'modules/events/helpers';
import {IEventsGroupedByDay} from 'modules/events/types';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {TastingMediaBanner} from '../TastingMediaBanner';

interface IProps {
    dayData: IEventsGroupedByDay;
    index: number;
}

export const Day: FC<IProps> = ({dayData, index}) => {
    const {date, events} = dayData;

    const {dateFormatted, dayOfWeek} = useMemo(() => {
        return {
            dateFormatted: getEventDate(date),
            dayOfWeek: getEventDayOfWeek(date),
        };
    }, [date]);

    return (
        <Box>
            <div className={style.titleArea} data-skeleton-item={true}>
                <Typography variant={'display-42-reg'}>{dateFormatted}</Typography>
                <Typography className={style.dayOfWeek} element={'div'} variant={'label-10-b'}>
                    {dayOfWeek}
                </Typography>
            </div>
            <div className={style.eventsList}>
                <EventsList events={events} />
            </div>
            {0 === index && <TastingMediaBanner />}
        </Box>
    );
};
